import React from 'react'
import { RiEyeOffLine } from "react-icons/ri"
import { FcGoogle } from "react-icons/fc";
import { BsInstagram } from "react-icons/bs";
import { IoIosArrowBack } from "react-icons/io";
function SignUp() {
  return (
    <>
      <div className="signup-container">

        {/* <a className="back-wel" href="./"> <IoIosArrowBack />Back</a> */}

        <div className="SignUp-H1P-Container">
          <h1 className="signUp-H">Let's get Started</h1>
          <p className="signUp-P">Get started wih your partner for business success</p>
        </div>

        <form action="" method="POST">

          <div className="BN-Input-Container">
            <label for="Business-name" className="BN">Business Name</label>
            <input type="text" name="name" placeholder="Global Industries" id="Business-name" className=" Business-name" required />
          </div>

          <div className="BN-Input-Container">
            <label for="name" className="BN">Full Name</label>
            <input type="text" name="name" placeholder="Moyo Chigoziem" id="name" className="name" required />
          </div>

          <div className="BN-Input-Container">
            <label for="Phone-Number" className="BN">Phone Number</label>
            <input type="number" name="phone-number" placeholder="999999999" id="phone-number" className="phone-number" required />
          </div>

          <div className="BN-Input-Container">
            <label for="email-address" className="BN">Email Address</label>
            <input type="email" name="email" placeholder="Moyosade@gmail.com" id="email" className="email-address" required />
          </div>

          <div className="BN-Input-Container">
            <label for="password" className="BN">Password</label>
            <input type="password" name="password" placeholder="*********" id="password" className="password" minLength="8" maxLength="15" required />
            {/* <span className="eye2">< RiEyeOffLine /></span> */}
          </div>

          <div className="SignUp-Button-Container">
            <button type="submit" className="button">SignUp</button>
          </div>

        </form>

        <div className="SignUp-description-Con">
          <p className="signUp-P2">By Signing in, you agree to our <a className="P2-link">Teams of use</a> and <a className="P2-link">Privacy Policy</a></p>
          <p className="signUp-P3">Already a user? <a className="P3-link" href="./Login">Sign In</a></p>
          <p className="signUp-P4">Or sign in using  <FcGoogle /> <BsInstagram /></p>
        </div>
      </div>
    </>
  )
}
export default SignUp;
